export default __webpack_public_path__ + "img/d70dca5eea2b4be7bb56f21c550e82b2.png";